import React from "react";
import PropTypes from "prop-types";
import { Field, ErrorMessage } from "formik";
import { Input } from "reactstrap";

// 用於Formik 有 initialValues的傳入
export function InputField({
  inputName,
  isInvalid,
  // disabled = false,
  type = null,
  style = {},
  className = null,
  maxLength = null,
  isReadOnly = null,
  placeholder = "",
  showError = true,
}) {
  return (
    <>
      <Field name={inputName} id={inputName} type="text">
        {({ field }) => (
          <Input
            {...field}
            className={className}
            id={inputName}
            invalid={isInvalid}
            disabled={isReadOnly}
            type={type}
            style={style}
            maxLength={maxLength}
            // readOnly={isReadOnly}
            value={field.value ? field.value : ""}
            placeholder={placeholder}
          />
        )}
      </Field>
      {showError && (
        <ErrorMessage name={inputName}>{(msg) => <span className={`text-danger ${className}`}>{msg}</span>}</ErrorMessage>
      )}
    </>
  );
}

export function FormikInputField({ name, style, ...restProps }) {
  return (
    <>
      <Field type="text" name={name}>
        {({ field, meta }) => {
          return <Input {...field} id={name} style={style} invalid={meta.error && meta.touched} {...restProps} />;
        }}
      </Field>
      <ErrorMessage name={name}>{(msg) => <span className="text-danger" style={style} >{msg}</span>}</ErrorMessage>
    </>
  );
}
FormikInputField.propTypes = {
  name: PropTypes.string.isRequired,
};
